import React from "react";

const RequiredMark = () => <span style={{ color: "var(--cw-danger)" }}> *</span>;

export default RequiredMark;
